import { Modal } from "antd";
import { FC } from "react";
import { useTranslation } from 'react-i18next';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  recogSentence: string|null;
}

const ShowSttModal: FC<IProps> = ({
  visible,
  setVisible,
  recogSentence,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      title="Student's Answer"
      visible={visible}
      onCancel={() => setVisible(false)}
      footer={[]}
    >
      <div style={{ fontSize: '15px' }}>
        <div style={{ color: 'firebrick' }}>
          학생의 녹음음성을 참고용으로 STT(Speech To Text)로 제공합니다. STT는 정확하지 않으니 채점 시 참고용으로만 사용해주세요.<br />
          The student's speech is converted to text (STT) to help teachers assess their score easily.<br />
          <b>However, STT is not 100% correct. So please just use it as a reference.</b>
        </div>
        <hr />
        {`[${t('class.tutor.text2')}]`}<br />
        {recogSentence}
      </div>
    </Modal>
  );
}

export default ShowSttModal;
